/**
 * Page metadata event - tracks basic page info when user navigates.
 *
 * @example Usage (preferred)
 * const { trackEvent } = useCohesion()
 *
 * trackEvent(EventCreators.pageMetadata({
 *   pageName: 'Home',
 *   siteSection: 'main'
 * }))
 */

import { z } from 'zod';

import { defineEvent } from '../event-factory';

export default defineEvent({
  eventName: 'healthgrades.PageMetaData.v4',

  // What data this event needs (see schema link for full details)
  // https://app.make.rvohealth.com/schemas/sch_2wMqJh1Y9EVzACYkZDlSCEhVzMN
  cohesionSchema: {
    pageName: z.string(),
    siteSection: z.string(),
    xBackendName: z.string().optional(),
    featureFlags: z.array(z.string()).optional(),
    internalTrackingCode: z.string().optional(),
    externalTrackingCodes: z.string().optional(),
    campaignProviderKey: z.string().optional(),
    programID: z.string().optional(),
  },

  tealiumMethodType: 'view',

  // Deduplication: One PageMetadata event per pageName per page view
  deduplication: {
    scope: 'page',
    keyBuilder: ({ pageName }) => pageName,
  },
});
